import { useState, useEffect } from 'react';

export function useCountryDetection() {
  const [country, setCountry] = useState(null); // Start with null
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const detectCountry = async () => {
      try {
        const response = await fetch('https://ipapi.co/json/');
        const data = await response.json();
        
        if (data.country_code) {
          // Convert to lowercase for react-phone-input-2
          setCountry(data.country_code.toLowerCase());
        }
      } catch (error) {
        console.error('Error detecting country:', error);
        // Keep null if detection fails
      } finally {
        setIsLoading(false);
      }
    };

    detectCountry();
  }, []);

  return { country, isLoading };
} 